import { UserBooking, PostInstallationMedia } from "../../types/responseTypes";

async function getInstallationMedia(booking: UserBooking): Promise<PostInstallationMedia | null> {
  try {
      const url = `https://ruuf-backend.online/installation/${booking.installationId}/media`;
      const timeout = new Promise<Response>((_, reject) =>
        setTimeout(() => reject(new Error("Request timed out")), 10000),
      );
      const response = await Promise.race([
        fetch(url, {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
        }),
        timeout,
      ]);

      if (!(response instanceof Response)) {
        throw response;
      }
      if (response.status === 200) {
        const media = await response.json();
        console.log("Post installation media fetched succesfully: ", media);
        return media;
      } else {
        throw new Error("Could not fetch installation media");
      }
    } catch (error) {
      console.error("Error fetching installation media:", error);
      return null;
    }
}

export default getInstallationMedia;
